import { Box, Container } from "@material-ui/core";

import React from "react";

const FeatureNotAvailable: React.FC = () => (
  <Container>
    <Box paddingTop={5}>
      <h1>This feature isn&apos;t available</h1>
    </Box>
  </Container>
);

export default FeatureNotAvailable;
